import React from 'react';
import { FeatureContainer, FeatureButton } from './style';

function Feature() {
  return (
    <FeatureContainer>
      <h1>Cake of the Day</h1>
      <p>Salted Caramel Chocolate Cake with Cocoa</p>
      <FeatureButton>Order Now</FeatureButton>
    </FeatureContainer>
  );
}

export default Feature;
